<template>
  <div class="exchange-detail detail-padding">
    <div class="spaceBetween" style="margin-bottom:0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">My Bid History</div>
      </div>
      <div class="spaceLeft search-form">
        <!-- <search-select @valChange="valChange($event,'type')" label="Token" :options="tokenOptions"/>
        <search-select @valChange="valChange($event,'result')" label="Result" :options="resultOptions"/> -->
        <!-- <div class="sapceLeft search-item">
          <el-input v-model="searchParams.number" placeholder="No..." suffix-icon="el-icon-search" @change="getList"/>
        </div> -->
      </div>
    </div>
    <div class="common-card">
      <el-table
        class="common-table"
        :data="tableList"
        v-loading="loading"
        highlight-current-row
      >
        <el-table-column
          prop="number"
          label="Number"
          align="left"
        >
          <template slot-scope="{ $index }">
            {{ queryParams.total - ((queryParams.page - 1) * queryParams.pageSize + $index) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="Cumulative investment Token"
          align="right"
        >
          <template slot-scope="{ row }">
            <div>
              <big-number :number.sync="row.amount" />
              <span class="td-word-sm">{{row.type}}</span>
            </div>

          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="result"
          label="Result"
           align="center"
        >
          <template slot-scope="{ row }">
            <div class="spaceCenter">
              <svg class="icon" aria-hidden="true" v-if="row.result != 'INVAILD'">
                <use :xlink:href="'#trn-' + (row.result == 'SUCCESS'?'success':'fail')"></use>
              </svg>
              <img src="@/assets/image/bid-none.png" style="width:0.2rem;margin-right:0.04rem;"/>
              <span :class="row.result == 'SUCCESS'?'success':'fail'"> {{$store.getters.bidStatusMap[row.result]}}</span>
            </div>

          </template>
        </el-table-column> -->
        <el-table-column
          prop="lmtAmt"
          label="Token Status"
          align="right"
        >
          <template slot-scope="{ row }">
            <span class="status" :class="row.status=='1' ? 'Returned' : 'Consumed'">
              <i class="iconfont trn-xiaohao"></i>
              {{row.status=='1' ? 'Returned' : 'Consumed'}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total.sync="queryParams.total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pageSize"
        @pagination="getList()"
      />
    </div>
  </div>
</template>

<script>
import { bidList } from "@/api/bid.js"
export default {
  components: {},
  data() {
    return {
      loading:false,
      searchParams:{
        type:undefined,
        result:undefined,
      },
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      tableList:[],
      tokenOptions:[
        {value:"UNIT",label:"Unit"},
        {value:"Rep",label:"Rep"}
      ],
      resultOptions:[
        {value:"SUCCESS",label:"successed"},
        {value:"FALSE",label:"Unsuccessful"},
        {value:"INVAILD",label:"Invalid"}
      ]
    };
  },
  computed: {},
  methods: {
    getList(repeat){
      bidList({
        account:this.$store.getters.metaMaskObj.account,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        ...this.searchParams,
      }).then(res => {
        this.tableList = res.result.data || [];
        this.queryParams.total = res.result.total || 0;

      })
    },
    valChange(obj, prop){
      this.searchParams[prop] = obj.value;
      this.queryParams = {
        total: 0,
        page: 1,
        pageSize: 10,
      }
      this.getList();
    },
    refresh(repeat){
      this.getList(repeat);
    }
  },
  created() {
    this.refresh("repeat");
  },
  mounted() {}
};
</script>
<style scoped lang="scss">

.detail-padding {
  padding-left: 10%;
  padding-right: 10%;
}
.common-card {
  background: #FAFAFA ;
  border-radius: 0.16rem;
  padding: 0.32rem 0.24rem;
}

.exchange-detail {
  .detail-title-1 {
    margin-bottom: 0.48rem;
  }
  .td-type-img{
    width: 0.52rem;
    margin-right:0.16rem;
  }
}
.success{
  font-size: 0.2rem;
  font-family: DMSans-Regular;
  font-weight: 400;
  color: #5EAE06;
}
.fail{
  font-size: 0.2rem;
  font-family: DMSans-Regular;
  font-weight: 400;
  color: #929DAD;
}
.status{
  background: rgba(62, 199, 157, 0.1);
  border-radius: 0.04rem;
  color:#1F1F1F;
  padding:0.07rem 0.12rem;
  font-size: 0.15rem;
  i{
    color:#3EC79D;
  }
  &.Consumed{
    background: rgba(217, 46, 47, 0.1);
    i{
      color:#D92E2F;
    }
  }
  &.Unreturned{
    background: rgba(147, 59, 216, 0.1);
    i{
      color:#933BD8;
    }
  }
}
</style>
